module.exports = __webpack_public_path__ + "static/media/post.cc60d5a8.png";